module.exports = __webpack_public_path__ + "media/day/116-f78eebe2.svg";